/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useTabsWithUrl, useEstateFetch } from "~/hooks";
import { isCloudResource } from "~/tools";
import {
  disabledFilterFields,
  DisabledFilters,
} from "~/views/estate/components/EstateFilters";
import { Ec2RelatedResourcesTab, EstateTabsData } from "../components";

type Props = {
  data: EstateTabsData;
};

export function Ec2SubnetTabs({ data }: Props) {
  const { activeTab, setActiveTab } = useTabsWithUrl();

  const resourceName =
    data.estateRecord && isCloudResource(data.estateRecord)
      ? data.estateRecord.name
      : "";

  const { result, ...filters } = useEstateFetch({
    defaultFilters: {
      typeSubtype: [
        "ec2/instance",
        "ec2/security-group",
        "ec2/network-interface",
      ],
      metadata: [
        {
          key: "subnetId",
          values: [resourceName],
        },
      ],
    },
    skipFields: disabledFilterFields.get(DisabledFilters.APPS),
    activeTab,
  });

  return (
    <Ec2RelatedResourcesTab
      data={data}
      dataEstate={result}
      estateFilters={filters}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
}
